// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createFromProduct, ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import BomTableProductCard, {
    BomTableProductCardStyles,
} from "@stoneage/App/Components/ProductDetails/BomTableProductCard";
import { CustomAppState } from "@stoneage/App/Store/Reducers";
import React from "react";
import { connect } from "react-redux";

interface OwnProps {
    childrenProducts: ProductModel[] | { description: string; productNumber: string }[];
    mainProductNumber: string;
    childrenType: "variants" | "bundles";
}

const mapStateToProps = (state: CustomAppState, ownProps: OwnProps) => {
    const mainProductNumber = ownProps?.mainProductNumber;
    return {
        products: state.xProductBom[mainProductNumber]?.products,
        productsInfo: state.xProductBom[mainProductNumber]?.productsInfo,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface BomTableProductChildStyles {
    bomTableProductCard?: BomTableProductCardStyles;
}

export const bomTableProductChildStyles: BomTableProductChildStyles = {};
const styles = bomTableProductChildStyles;
const BomTableProductChild = ({ childrenProducts, mainProductNumber, childrenType, products, productsInfo }: Props) => {
    if (!childrenProducts) {
        return null;
    }

    return (
        <>
            {childrenType === "variants" ? (
                <>
                    {childrenProducts.map((child: any) => {
                        const childProductInfo = createFromProduct(child);
                        return (
                            <BomTableProductCard
                                key={child.id}
                                mainProductNumber={mainProductNumber}
                                product={child}
                                productInfo={childProductInfo}
                                extendedStyles={styles.bomTableProductCard}
                            />
                        );
                    })}
                </>
            ) : (
                <>
                    {childrenProducts.map((child: any) => {
                        const product = products[child?.productNumber];
                        const childProductInfo: ProductInfo = productsInfo?.[child?.productNumber];
                        return (
                            <BomTableProductCard
                                key={product.id}
                                mainProductNumber={mainProductNumber}
                                product={product}
                                productInfo={childProductInfo}
                                extendedStyles={styles.bomTableProductCard}
                            />
                        );
                    })}
                </>
            )}
        </>
    );
};

export default connect(mapStateToProps)(BomTableProductChild);
